import React, { Component } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { convertFromHTML } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import Box from "@mui/material/Box";

export default class TableTextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      showToolbar: false, // Kezdetben az eszköztár rejtve van
    };
    this.debounceTimeout = null; // Késleltetéshez használt timeout
  }

  componentDidMount() {
    // Ha a szülő komponens átadott egy HTML-t, akkor azt betöltjük
    if (this.props.initialHtml) {
      this.loadHtmlContent(this.props.initialHtml);
    }
  }

  componentDidUpdate(prevProps) {
    // Amikor a szülő komponens új HTML-t ad át, betöltjük azt
    if (prevProps.initialHtml !== this.props.initialHtml) {
      this.loadHtmlContent(this.props.initialHtml);
    }
  }

  // HTML betöltése és átalakítása draft-js formátumba
  loadHtmlContent = (html) => {
    const blocksFromHTML = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    const editorState = EditorState.createWithContent(contentState);
    this.setState({ editorState });
  };

  // A szerkesztő állapotának frissítése
  onEditorStateChange = (editorState) => {
    this.setState({ editorState });

    // Késleltetett változáskezelés a szülő komponens felé
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      const htmlContent = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );
      this.props.onChange(htmlContent);
    }, (this.props.debounceMs || 300));
  };

  // Fókusz esemény kezelése
  render() {
    const { editorState } = this.state;

    return (
      <Box
      sx={{
        '& .rdw-editor-toolbar': {
          display: 'none'
        },
        '& .public-DraftStyleDefault-block': {
          margin: '0px'
        },
        '& .rdw-editor-main': {
          maxHeight: '30px'
        }
      }}
      >
        <Editor
          editorKey={`${this.props?.column?.columnName?this.props?.column?.columnName:'test'}-editor`}
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={this.onEditorStateChange}
          toolbar={{ options: [] }}
        />
      </Box>
    );
  }
}
